// extracted by mini-css-extract-plugin
export default {"section":"Servicios_section__nyzJt","grid":"Servicios_grid__pDh-C"};